import React from "react";
import bg404 from "../../img/bg.svg";

const NotFound = () => {
  return (
    <div>
      <img src={bg404} alt='' />
    </div>
  );
};

export default NotFound;
